import { notifyOnError } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { BackendService } from '../BackendService';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import { IBetaRewards, IBetaRewardsService } from './betaRewardsServiceTypes';

const EMPTY_REWARD: IBetaRewards = {
	money: 0,
	donate: 0,
};

export class BetaRewardsService implements IBetaRewardsService {
	private readonly reward = new Subject<IBetaRewards>(EMPTY_REWARD);

	constructor(
		private readonly gameConfig: GameConfigService,
		private readonly rpc: RpcService,
		private readonly backend: BackendService,
	) {
		this.gameConfig.getConfigs().subscribe((configs) => {
			if (!configs?.gameplay) {
				return;
			}

			this.reward.next({
				money: configs.gameplay.betaRewardsMoney,
				donate: configs.gameplay.betaRewardsDonate,
			});
		});
	}

	public getReward(): IObservable<IBetaRewards> {
		return this.reward;
	}

	@notifyOnError
	public async claimReward(): Promise<void> {
		const { claimed } = await this.backend.invoke<{ claimed: boolean }>(
			'closedBeta:redeemReward',
		);
		if (claimed) {
			await this.close();
		}
	}

	@notifyOnError
	public async close(): Promise<void> {
		await this.rpc.invokeClient('betaRewards:close');
	}
}
